import {AiOutlineInstagram} from 'react-icons/ai'
import {AiFillLinkedin} from 'react-icons/ai'
import {AiFillFacebook} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiFillYoutube} from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://github.com/raisulislampiaus', icon: <AiFillGithub/>},
    {id: 2, link: 'https://www.linkedin.com/in/raisulislampiaus/', icon: <AiFillLinkedin/>},
    {id: 3, link: 'https://www.facebook.com/raisulislampiaus/', icon: <AiFillFacebook/>},
    {id: 4, link: 'https://www.instagram.com/raisulislampiaus/', icon: <AiOutlineInstagram/>},
    {id: 5, link: 'https://www.youtube.com/channel/UChrTfQ9Em3M20z4h3r1GerQ', icon: <AiFillYoutube/>},
    
]

export default data